import { useCallback, useEffect, useRef, useState } from "react";

/**
 * マウント時のみsetStateを行う
 * useState()のラップ関数
 * @param {any} defaultValue
 */
export const useStateSafe = (defaultValue) => {
  const [state, setState] = useState(defaultValue);
  const isMountedRef = useRef(false);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const setStateSafe = useCallback((value) => {
    if (isMountedRef.current) setState(value);
  }, []);

  return [state, setStateSafe];
};
